import React from 'react';
import PropTypes from 'prop-types';

import { Spinner } from 'src/components/basic';
import SVGIcon from 'src/components/svg';

import constants from 'src/constants';

import { lang } from 'src/helpers';

export class Table extends React.PureComponent {
  canPreviousPage = () => {
    const {pageIndex} = this.props;
    return pageIndex > 0;
  };

  canNextPage = () => {
    const {pageIndex, pageSize, total} = this.props;
    const pageCount = Math.floor(total / pageSize);
    return pageIndex < pageCount;
  };

  renderRow = (item, i) => {
    const {
      columns,
      renderExtend,
    } = this.props;
    if (renderExtend) {
      return <div
        data-testid={'table-row'}
        className={'mc-flex-10-col'}
        key={'mc-table-item-' + (
          item.id + '-' + i
        )}
      >
        <div
          className={'mc-row ' + (
            i % 2 === 1 ? 'mc-even' : 'mc-odd'
          )}
        >
          {columns.map((col, j) => (
            <div
              key={'mc-table-item-' + item.id + '-' + j}
              className={'mc-cell'}
              style={col.cellStyles || {}}
            >
              {col.render(item, i)}
            </div>
          ))}
        </div>
        {renderExtend(item, i)}
      </div>;
    }

    return <div
      data-testid={'table-row'}
      key={'mc-table-item-' + (
        item.id + '-' + i
      )}
      className={'mc-row ' + (
        i % 2 === 1 ? 'mc-even' : 'mc-odd'
      )}
    >
      {columns.map((col, j) => (
        <div
          key={'mc-table-item-' + item.id + '-' + j}
          className={'mc-cell'}
          style={col.cellStyles || {}}
        >
          {col.render(item, i)}
        </div>
      ))}
    </div>;
  };

  renderPageButton = (i) => {
    const {pageIndex, gotoPage} = this.props;
    return <li
      key={'paging-' + i}
      className={'mc-paginate_button mc-page-item ' + (
        i === pageIndex ? 'active' : ''
      )}
    >
      <button
        onClick={() => {
          if (pageIndex !== i) {
            gotoPage(i);
          }
        }}
        className="page-link"
      >
        {i + 1}
      </button>
    </li>;
  };

  render() {
    const {
      loading,
      noResults,
      searchQuery,
      columns,
      data,
      pageIndex,
      pageSize,
      showPagination,
      gotoPage,
      total,
      setPageSize,
      extendRows = '',
      footer = '',
      template = '1',
      className = '',
    } = this.props;
    const pageCount = Math.ceil(total / pageSize) - 1;

    const from = Math.max(0, pageIndex - 2) + 1;
    const to = Math.min(pageCount, pageIndex + 2);

    let pagingList = [
      this.renderPageButton(0),
    ];

    if (from > 1) {
      pagingList.push('...');
    }
    for (let i = from; i < to; i++) {
      pagingList.push(
        this.renderPageButton(i),
      );
    }
    if (to < pageCount) {
      pagingList.push('...');
    }
    if (pageCount > 0) {
      pagingList.push(
        this.renderPageButton(pageCount),
      );
    }

    return (
      <>
        <div className={`mc-table-basic template-${template} ${className}`}>
          <div className={'mc-table-header'}>
            {columns.map((item, i) => (
              <div key={'mc-patient-th-' + i} className={'mc-cell ' + (item.cellClassName || '')} style={item.cellStyles || {}}>
                {lang.t(item.label)}
              </div>
            ))}
          </div>
          <div className={'mc-table-body'}>
            {noResults && !searchQuery && (
              <div style={{textAlign: 'center', marginTop: '1rem'}}>
                {lang.t('No results yet')}
              </div>
            )}
            {noResults && searchQuery && (
              <div style={{textAlign: 'center', marginTop: '1rem'}}>
                {lang.t('Nothing found')}
              </div>
            )}
            {loading && (
              <div style={{textAlign: 'center', marginTop: '1rem'}}>
                <Spinner/>
              </div>
            )}
            {!loading && data && data.map(this.renderRow)}
            {extendRows}
          </div>
        </div>
        {footer}
        {showPagination &&
          (
            [ '3', '1' ].indexOf(template) < 0 ? (
              <div className="mc-tablePagination">
                <div style={{flexGrow: 1}}>
                  <ul className="mc-pagination">
                    <li className="mc-paginate_button mc-page-item first">
                      <button
                        onClick={() => gotoPage(0)}
                        disabled={!this.canPreviousPage()}
                        className="page-link"
                      >
                        <SVGIcon iconname={'double-arrow-icon'}/>
                      </button>
                    </li>
                    {' '}
                    <li className="mc-paginate_button mc-page-item previous">
                      <button
                        onClick={() => gotoPage(pageIndex - 1)}
                        disabled={!this.canPreviousPage()}
                        className="page-link"
                      >
                        <SVGIcon iconname={'arrow-icon'}/>
                      </button>
                    </li>
                    {' '}
                    {pagingList}
                    <li className="mc-paginate_button mc-page-item next">
                      <button
                        onClick={() => gotoPage(pageIndex + 1)}
                        disabled={!this.canNextPage()}
                        className="page-link"
                      >
                        <SVGIcon iconname={'arrow-icon'}/>
                      </button>
                    </li>
                    {' '}
                    <li className="mc-paginate_button mc-page-item last">
                      <button
                        onClick={() => gotoPage(pageCount)}
                        disabled={!this.canNextPage()}
                        className="page-link"
                      >
                        <SVGIcon iconname={'double-arrow-icon'}/>
                      </button>
                    </li>
                    {' '}
                  </ul>
                </div>
                <div className={'mc-flex'}>
                  <div className="mc-dataTables_length align-items-center">
                    <label>
                      <select
                        className="mc-custom-select mc-custom-select-sm mc-form-control mc-form-control-sm"
                        value={pageSize}
                        onChange={(e) => {
                          setPageSize(Number(e.target.value));
                        }}
                      >
                        {constants.general.limit_options.map((pageSize) => (
                          <option key={pageSize} value={pageSize}>
                            {pageSize}
                          </option>
                        ))}
                      </select>
                    </label>
                  </div>
                  <span className="mc-dataTables_info">
                  {lang.t('Showing {:from} - {:to} of {:total}', {
                    from: pageSize * pageIndex + 1,
                    to: pageCount === pageIndex + 1 ? total : pageSize * (
                      pageIndex + 1
                    ),
                    total,
                  })}
                </span>
                </div>
              </div>
            ) : (
              <div className="mc-tablePagination template-3">
                <div className={'mc-grow'}></div>
                <ul className="mc-pagination">
                  <li className="mc-page-item">
                    <button
                      onClick={() => gotoPage(pageIndex - 1)}
                      disabled={!this.canPreviousPage()}
                      className="page-link mc-no-style-btn"
                    >
                      {lang.t('Previous')}
                    </button>
                  </li>
                  {' '}
                  {pagingList}
                  <li className="mc-page-item">
                    <button
                      onClick={() => gotoPage(pageIndex + 1)}
                      disabled={!this.canNextPage()}
                      className="page-link mc-no-style-btn"
                    >
                      {lang.t('Next')}
                    </button>
                  </li>
                  {' '}
                </ul>
              </div>
            )
          )}
      </>
    );
  }
}

Table.defaultProps = {
  showPagination: true,
  data: [],
  pageIndex: 1,
};

Table.propTypes = {
  showPagination: PropTypes.bool,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array,
  pageIndex: PropTypes.number,
  pageSize: PropTypes.number,
  gotoPage: PropTypes.func,
};
